/**
 * @function isHomePage - Checks if the current page is the home page
 * @returns {boolean} - true if on home page
 */
export function isHomePage() {
	return window.location.pathname === "/";
}
